// extracted by mini-css-extract-plugin
export default {"mobileMenu":"MobileMenu_mobileMenu__STBJl","container":"MobileMenu_container__LMX7b","navItem":"MobileMenu_navItem__HuTsa","close":"MobileMenu_close__I4+wU"};